import React from "react";
import { useLocation } from "react-router-dom";
import ModuleSubtopic from "../../../ModuleSubtopic";

const ArrayBoothMultiplier = () => {
  const location = useLocation();
  const { subtopics, subjectPath } = location.state || { subtopics: [], subjectPath: '' };

  return (
  <ModuleSubtopic
      subtopics={subtopics}
      subjectPath={subjectPath}
      title="Array Multiplier and Booth Multiplier"
    videos={[
      "https://www.youtube.com/embed/gTxgiJHBfsI?si=pBj8NGIwhK-vYlNn",
      "https://www.youtube.com/embed/7uWozW5kqfc?si=juNqfdBxnw8h_GtV"
    ]}
    takeaways={[]}
    questions={[
      "1) Specify the steps involved in multiplying -5 x 9 using Booth Multiplier",
      "2) Design a Combinational Circuit that performs multiplication of 2 bit numbers. Draw the corresponding Truth Table and Logic Diagrams",
      "3) Calculate the product of 4-bit signed numbers 0011 and 1100 using Booth's Algorithm and describe the architecture of booth multiplier"
    ]}
    exampleVideos={[]}
  />
);
}

export default ArrayBoothMultiplier;
